<template>
    <span class="singer-des" v-if="recordInfo">
        <i v-if="contributionList && contributionList.length>0">
            <i href="javascript:;" v-for="(cItem, cIndex) in contributionList" :key="'creator' + cIndex">
                <router-link 
                    v-if="cItem.agent && cItem.agentLabel && cItem.agent['@id'] && cItem.agent['@id'].search('http://data.library.sh.cn/entity/person/')>=0"
                    :to="'/musician-detail/' + encodeURIComponent(cItem.agent['@id'])"
                >
                    {{ cItem.agentLabel.lastIndexOf(',')>0? cItem.agentLabel.slice(0,cItem.agentLabel.length-1):cItem.agentLabel }}（{{ cItem.role.lastIndexOf('.')>0?cItem.role.slice(0,cItem.role.length-1):cItem.role }}）<template v-if="cIndex<contributionList.length-1">、</template>
                </router-link>
                <router-link
                    v-else-if="cItem.agent && cItem.agentLabel && cItem.agent['@id'] && cItem.agent['@id'].search('http://data.library.sh.cn/entity/organization/')>=0"
                    :to="'/company-detail/' + encodeURIComponent(cItem.agent['@id'])"
                >
                    {{ cItem.agentLabel.lastIndexOf(',')>0? cItem.agentLabel.slice(0,cItem.agentLabel.length-1):cItem.agentLabel }}（{{ cItem.role.lastIndexOf('.')>0?cItem.role.slice(0,cItem.role.length-1):cItem.role }}）<template v-if="cIndex<contributionList.length-1">、</template>
                </router-link>
                <template v-else>
                    <template v-if="cItem.agentLabel">{{ cItem.agentLabel.lastIndexOf(',')>0? cItem.agentLabel.slice(0,cItem.agentLabel.length-1):cItem.agentLabel }}（{{ cItem.role.lastIndexOf('.')>0?cItem.role.slice(0,cItem.role.length-1):cItem.role }}）
                        <template v-if="cIndex<contributionList.length-1">、</template>
                    </template>
                </template>
            </i>
        </i>
        <i v-else>
            <!--规范人-单值--->
            <i v-if="recordInfo.contribution.agent &&  recordInfo.contribution.agentLabel && recordInfo.contribution.agent['@id'] && recordInfo.contribution.agent['@id'].search('http://data.library.sh.cn/entity/person/')>=0" >
                <router-link :to="'/musician-detail/' + encodeURIComponent(recordInfo.contribution.agent['@id'])" >
                    {{ recordInfo.contribution.agentLabel }}（{{ recordInfo.contribution.role }}） 
                </router-link>
            </i>
            <!--规范机构-单值--->
            <i v-else-if="recordInfo.contribution.agent  &&  recordInfo.contribution.agentLabel && recordInfo.contribution.agent['@id'] && recordInfo.contribution.agent['@id'].search('http://data.library.sh.cn/entity/organization/')>=0" >
                <router-link :to="'/company-detail/' + encodeURIComponent(recordInfo.contribution.agent['@id'])" >
                    {{ recordInfo.contribution.agentLabel }}（{{ recordInfo.contribution.role }}） 
                </router-link>
            </i>
            <!--未规范人或机构-单值--->
            <template v-else> 
                <template v-if="recordInfo.contribution.agentLabel">{{ recordInfo.contribution.agentLabel }}（{{ recordInfo.contribution.role }}）</template>
            </template>
        </i>
    </span>
</template>

<script>
export default {
    name: "Singer",
    props: {
        recordInfo: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            contributionList: []//单独处理《梅兰芳》chenss 20230828
            
        }
    },
    created() {
      
    }
    ,
  mounted() {
    if(this.recordInfo.contribution && Array.isArray(this.recordInfo.contribution)){
              this.contributionList = this.recordInfo.contribution;
             if(this.recordInfo["@id"].search('ds5h44l5i4cv9vig')>=0){//单独处理《梅兰芳》chenss 20230828
              for(let i=0;i<this.contributionList.length;i++){
                switch(this.contributionList[i].agentLabel){
                    case '梅兰芳':
                        this.contributionList[i].sort =1;
                        break;
                    case '尚小云':
                        this.contributionList[i].sort =2;
                        break;
                    case '荀慧生':
                        this.contributionList[i].sort =3;
                        break;
                    case '程砚秋':
                        this.contributionList[i].sort =4;
                        break;
                    case '程艳秋':
                        this.contributionList.splice(i,1);//删除程艳秋
                        break;
                    default:
                        this.contributionList[i].sort =5;
                        break;
                }
              }

              this.contributionList.sort((p1, p2) => {
                   return p1.sort - p2.sort
              })//排序 单独处理《梅兰芳》chenss 20230828

             }
       }
   
  },
  methods: {
  }
}
</script>